<template>
  <div class="page-header-index-wide" style="display: flex;">
    <div style="width: 70%;">
      <a-row :gutter="[8, 0]" class="playground" style="margin: -4px 0;">
        <a-col :sm="24" :md="12" :xl="8" class="playground" v-for="item in taskList" :key="item.key">
          <chart-card :loading="loading" :needNum="false" title=" " class="task">
            <a-tooltip :title="item.tips" slot="action">
              <a-icon type="info-circle-o" />
            </a-tooltip>
            <div slot="content">
              <a-row :gutter="[8, 0]">
                <a-col :span="6" style="display: flex;justify-content: center;">
                  <div class="task-icon">
                    <a-icon type="audit" />
                  </div>
                </a-col>
                <a-col :span="18">
                  <div class="task-content">
                    <div class="task-label">{{item.label}}</div>
                    <div class="task-num">{{item.num}}</div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </chart-card>
        </a-col>
      </a-row>
      <a-row :gutter="[8, 0]" class="playground">
        <a-col :sm="24" :md="24" :xl="24">
          <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" :title="$t('业务数量')" :needNum="false" style="width: 100%;height: 516px;" class="finishcard">
            <div slot="action">
              <a-radio-group default-value="1" @change="onChange">
                <a-radio-button value="1">
                  {{ $t('近一周') }}
                </a-radio-button>
                <a-radio-button value="2">
                  {{ $t('近一月') }}
                </a-radio-button>
                <a-radio-button value="3">
                  {{ $t('近一年') }}
                </a-radio-button>
              </a-radio-group>
              <!-- <a-range-picker style="margin-left: 20px;">
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker> -->
            </div>
            <div slot="content" style="height: 400px;width: 100%;">
              <div id="option2" style="height: 100%;width: 100%;"></div>
            </div>
          </chart-card>
          </a-col>
        </a-col>
      </a-row>
      <!-- <a-row :gutter="[8, 0]" class="playground">
        <a-col :sm="24" :md="24" :xl="24">
          <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" title="动态" :needNum="false" style="width: 100%;height: 260px;" class="trend">
            <div slot="content" style="height: 200px;width: 100%;padding: 10px 0;">
              <div v-for="item in trendData" :key="item.key" style="padding: 5px 0;">
                <div style="display: flex;align-items: center;">
                  <div style="width: 32px;height: 32px;margin-right: 10px;">
                    <a-avatar style="backgroundColor:#3BA1FF;width: 100%;height: 100%;" icon="user" />
                  </div>
                  <div style="flex: 1;font-weight: bold;letter-spacing:2px;" v-html="item.title"></div>
                  <div style="width:150px;color: #999;">2024-8-8 17:35:25</div>
                </div>
              </div>
            </div>
          </chart-card>
          </a-col>
        </a-col>
      </a-row> -->
    </div>
    <div style="width: 30%;">
      <a-row :gutter="[8, 0]" class="playground" style="margin: -4px 0;">
        <a-col :sm="24" :md="24" :xl="24">
          <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" title="" :needNum="false">
            <div slot="content" class="table-fixed" style="height: 300px;">
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" :tab="$t('巡检任务')">
                  <a-table
                    ref="table"
                    size="middle"
                    :scroll="{x:true,y:true}"
                    bordered
                    rowKey="id"
                    :pagination="false"
                    :columns="columns"
                    :dataSource="dataSource"
                    :loading="loading"
                    :components="drag(columns)"
                    style="height: 100%;">
                    <template slot="procDefVersion" slot-scope="text, record, index">
                        <el-tag size="medium" >V{{ record.procDefVersion }}</el-tag>
                    </template>
                    <template slot="startUserName" slot-scope="text, record, index">
                       <label>{{record.startUserName}} <el-tag type="info" size="mini">{{record.startDeptName}}</el-tag></label>
                    </template>
                    <template slot="taskState" slot-scope="text, record">
                      <a-tag v-if="record.taskState == 0">{{ $t('未分配') }}</a-tag>
                      <a-tag color="blue" v-if="record.taskState == 1">{{ $t('已分配') }}</a-tag>
                      <a-tag color="red" v-if="record.taskState == 2">{{ $t('结束') }}</a-tag>
                    </template>
                  </a-table>
                </a-tab-pane>
                <!-- <a-tab-pane key="2" tab="我的已办">
                  <a-table
                    ref="table"
                    size="middle"
                    :scroll="{x:true,y:true}"
                    bordered
                    rowKey="id"
                    :pagination="false"
                    :columns="columns"
                    :dataSource="dataSource"
                    :loading="loading"
                    :components="drag(columns)"
                    style="height: 100%;">
                    <template slot="procDefVersion" slot-scope="text, record, index">
                        <el-tag size="medium" >V{{ record.procDefVersion }}</el-tag>
                    </template>
                    <template slot="startUserName" slot-scope="text, record, index">
                       <label>{{record.startUserName}} <el-tag type="info" size="mini">{{record.startDeptName}}</el-tag></label>
                    </template>
                  </a-table>
                </a-tab-pane> -->
                <a-button slot="tabBarExtraContent" type="link" @click="onMore">{{ $t('更多') }}</a-button>
              </a-tabs>
            </div>
          </chart-card>
          </a-col>
        </a-col>
      </a-row>
      <a-row :gutter="[8, 0]" class="playground" style="margin: -4px 0;margin-top: 20px;">
        <a-col :sm="24" :md="24" :xl="24">
          <a-col :span="24">
          <chart-card :loading="loading" :bordered="false" :title="$t('巡检任务本月完成情况')" :needNum="false" style="width: 100%;" class="finishcard">
            <div slot="content" style="width: 100%;">
              <div style="display: flex;width: 100%;height: 180px;">
                <div style="flex: 1;font-size: 12px;">
                  {{ $t('本月已完成') }}
                  <a-progress strokeColor="#3BA1FF" :percent="taskTimelyFinishRate" :strokeWidth="15" class="finish" status="normal" />
                  {{ $t('本月未完成') }}
                  <a-progress strokeColor="#FF0000" :percent="taskUnFinishRate" :strokeWidth="15" class="notfinish" status="normal" />
                  {{ $t('本月超时未完成') }}
                  <a-progress strokeColor="#FFC328" :percent="taskTimeoutUnFinishRate" :strokeWidth="15" class="timeout" status="normal" />
                  {{ $t('本月按时完成率') }}
                  <a-progress strokeColor="#87d068" :percent="taskFinishRate" :strokeWidth="15" class="timefinish" status="normal" />
                </div>
                <div style="width: 180px;height: 100%;display: flex;align-items: center;justify-content: center;flex-direction:column;font-weight: bold;font-size: 20px;">
                  <div>{{ $t('巡检总数') }}</div>
                  <div>{{taskAllNum}}</div>
                </div>
              </div>
              <div style="display: flex;align-items: center;justify-content: center;width: 100%;">
                <!-- <div style="display: flex;flex-direction: column;;align-items: center;width: 32%;">
                  <div style="margin-bottom: 10px;">完成率</div>
                  <a-progress type="dashboard" :stroke-color="{'100%': '#108ee9','0%': '#87d068',}" :percent="taskFinishRate" :strokeWidth="13" />
                </div> -->
                <!-- <div style="display: flex;flex-direction: column;;align-items: center;width: 32%;">
                  <div style="margin-bottom: 10px;">及时率</div>
                  <a-progress type="dashboard" :stroke-color="{'100%': '#108ee9','0%': '#87d068',}" :percent="25" :strokeWidth="13" />
                </div>
                <div style="display: flex;flex-direction: column;;align-items: center;width: 32%;">
                  <div style="margin-bottom: 10px;">执行率</div>
                  <a-progress type="dashboard" :stroke-color="{'100%': '#108ee9','0%': '#87d068',}" :percent="45" :strokeWidth="13" />
                </div> -->
              </div>
              <div>
                
              </div>
            </div>
          </chart-card>
          </a-col>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  import ChartCard from '@/components/ChartCard'
  import echarts from 'echarts'
  import '@/assets/less/TableExpand.less'
  // import { mixinDevice } from '@/utils/mixin'
  // import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import { postAction,getAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default{
    components:{
      ChartCard
    },
    mixins:[TableDragResize],
    data() {
      return{
        loading: false,
        url: {
          list: "/jeecg-engineering/inspection/inspectionTask/list",
          indexTodayToDoTaskByUser: "/jeecg-engineering/inspection/inspectionTask/indexTodayToDoTaskByUser",
          indexTodayDoneTaskByUser: "/jeecg-engineering/inspection/inspectionTask/indexTodayDoneTaskByUser",
          indexWillEndTaskByUser: "/jeecg-engineering/inspection/inspectionTask/indexWillEndTaskByUser",
          indexTaskNumByTimeType: "/jeecg-engineering/inspection/inspectionTask/indexTaskNumByTimeType",
          indexTaskFinishRateByTimeType: "/jeecg-engineering/inspection/inspectionTask/indexTaskFinishRateByTimeType",
        },
        dataSource: [],
        queryParam: {
          workState: 0,
          pageSize: 6
        },
        trendData: [
          {title:'林东东在<a>xX巡检项目</a>中发布了提交了<a>新增报修</a>任务',time:'2024-08-08 17:57:55'},
          {title:'林东东在<a>xX巡检项目</a>中发布了提交了<a>新增报修</a>任务',time:'2024-08-08 17:57:55'},
          {title:'林东东在<a>xX巡检项目</a>中发布了提交了<a>新增报修</a>任务',time:'2024-08-08 17:57:55'},
          {title:'林东东在<a>xX巡检项目</a>中发布了提交了<a>新增报修</a>任务',time:'2024-08-08 17:57:55'},
        ],
        taskFinishRate: 0,
        taskUnFinishRate: 0,
        taskTimeoutUnFinishRate: 0,
        taskTimelyFinishRate: 0,
        taskAllNum: 0,
      }
    },
    computed:{
      taskList() {
        return [{
          label: this.$t('当日巡检任务数'),
          num: 0,
          tips: this.$t('这是当日巡检任务数')
        }, {
          label: this.$t('未巡检任务数'),
          num: 0,
          tips: this.$t('这是未巡检任务数')
        }, {
          label: this.$t('即将过期任务数'),
          num: 0,
          tips: this.$t('小于三天的统计')
        }]
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('任务名称'),
            align:"center",
            dataIndex: 'taskName',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('任务类型'),
            align:"center",
            dataIndex: 'taskCategory',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('临时任务');
              }else if(t == 1){
                return this.$t('日常任务');
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('任务状态'),
            align:"center",
            dataIndex: 'taskState',
            scopedSlots: { customRender: 'taskState' },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('开始时间'),
            align:"center",
            dataIndex: 'taskBeganTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('结束时间'),
            align:"center",
            dataIndex: 'taskEndTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('执行人员类型'),
            align:"center",
            dataIndex: 'taskImplementType',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('班组');
              }else if(t == 1){
                return this.$t('成员');
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('执行人员(班组/成员)'),
            align:"center",
            dataIndex: 'taskImplementName',
            width: 150,
            ellipsis: true,
          },
        ]
      },
    },
    mounted(){
      this.getTodayToDoTaskByUser();
      this.getTodayDoneTaskByUser();
      this.getWillEndTaskByUser();
      this.getTaskNumByTimeType(1);
      this.getTaskFinishRateByTimeType();
      this.setMytodoList();
    },
    methods:{
      // 当日巡检任务数
      getTodayToDoTaskByUser(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.indexTodayToDoTaskByUser,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskList[0].num = data.toDo;
          }
        })
      },
      // 未巡检任务数
      getTodayDoneTaskByUser(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.indexTodayDoneTaskByUser,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskList[1].num = data.done;
          }
        })
      },
      // 即将过期任务数
      getWillEndTaskByUser(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.indexWillEndTaskByUser,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskList[2].num = data.willEnd;
          }
        })
      },
      // 获取业务数量
      getTaskNumByTimeType(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.indexTaskNumByTimeType,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption2(data.xdata,data.ydata);
          }
        })
      },
      getTaskFinishRateByTimeType(){
        postAction(this.url.indexTaskFinishRateByTimeType,{queryType:2}).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskFinishRate = (data.taskTimelyFinishRate*100).toFixed(2);//完成率
            this.taskUnFinishRate = (data.taskUnFinishRate*100).toFixed(2);//未完成率
            this.taskTimeoutUnFinishRate = (data.taskTimeoutUnFinishRate*100).toFixed(2);//超时未完成
            this.taskTimelyFinishRate = (data.taskFinishRate*100).toFixed(2);//按时完成
            this.taskAllNum = data.taskAllNum;//巡检总数数量
          }
        })
      },
      onChange(e){
        this.getTaskNumByTimeType(e.target.value);
      },
      setMytodoList(){
        getAction(this.url.list,{pageNo:1,pageSize:5,order:'desc',column: 'createTime'}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
          }
        })
      },
      setOption2(xData,yData){
        var chartDom = document.getElementById('option2');
        var myChart = echarts.init(chartDom);
        var option = {
          title: {
            text: this.$t('业务数量趋势'),
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xData,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          color: ['#3BA1FF'],
          series: [
            {
              name: this.$t('巡检任务'),
              type: 'bar',
              barWidth: '30',
              data: yData
            }
          ]
        };
        option && myChart.setOption(option);
      },
      onMore(){
        this.$router.push('/inspectionManagement/taskManagement/inspectionTasks');
      },
    }
  }
</script>

<style scoped lang="less">
  .task{
    /deep/.ant-card-body{
      height: 150px !important;
      padding: 20px !important;
    }
    .task-icon {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background-color: rgb(0, 162, 255);
      display: flex;
      align-items: center;
      justify-content: center;
    
      .anticon-audit {
        color: #fff;
        font-size: 30px;
      }
    }
    
    .task-content {
      margin-left: 30px;
    
      .task-label {
        font-size: 14px;
        color: #999;
      }
    
      .task-num {
        font-size: 30px;
        font-weight: bold;
        color: #000;
      }
    }
  }
  /deep/.ant-card-body{
    padding: 20px !important;
  }
  /deep/.ant-table-thead > tr > th{
    background-color: #fafafa;
  }
  /deep/.ant-table-thead > tr > th:not(:first-child):before,
  /deep/.ant-table-thead > tr > th:not(:last-child):after{
    background-color: #e8e8e8;
  }
  /deep/.ant-progress-line{
    margin-bottom: 10px;
    margin-top: 5px;
  }
  /deep/.ant-progress-circle .ant-progress-text{
    font-size: 2em;
  }
  /deep/.finish .ant-progress-inner{
    background-color: #85C4FF;
  }
  /deep/.notfinish .ant-progress-inner{
    background-color: #FF8D8D;
  }
  /deep/.timeout .ant-progress-inner{
    background-color: #FFE6A5;
  }
  /deep/.timefinish .ant-progress-inner{
    background-color: rgba(135,208,104,0.3);
  }
  /deep/.trend .ant-card-body{
    height: 100% !important;
  }
  /deep/.finishcard .ant-card-body{
    height: 100% !important;
  }
  /deep/.ant-progress-circle{
    width: 100%;
    height: calc(100% - 31px);
    .ant-progress-inner{
      width: 100% !important;
      height: 100% !important;
    }
  }
  .page-header-index-wide{
    flex-direction: row;
  }
</style>